
import React from "react";
import ProjectMap from "./ProjectMap";
import { Box, Button, Grid2, IconButton, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { IoCall } from "react-icons/io5";
import { MdDirections } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";


const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%'
}));

const columns = [
    {
        name: "Project Name",
        field: "project_name",
    },
    {
        name: "Budget Cost (In Cr)",
        field: "budget",
    },
    {
        name: "Location",
        field: "location",
    },

    // {
    //     name: "% Completion",
    //     field: "completion",
    // },
    // {
    //     name: "Overall Health",
    //     field: "health",
    // },
    {
        name: "Head Name",
        field: "head_name",
    },
    {
        name: "",
        field: "change_number",
    },
]
const ProjectHome = () => {

    const navigate = useNavigate();
    const projectList = useGetAllProjectsQuery();

    const data = [
        {
            change_number: "P-001",
            project_name: "Screening Plant 1",
            location: "Kirandul, Chhattisgarh",
            completion: "65%",
            health: "On Track",
            head_name: "Ashok Verma",
            color: 'green',
        },
        {
            change_number: "P-002",
            project_name: "Screening Plant 2",
            location: "Bacheli, Chhattisgarh",
            completion: "78%",
            health: "At Risk",
            head_name: "Pawan Sharma",
            color: 'red',
        },
        {
            change_number: "P-003",
            project_name: "Screening Plant 3",
            location: "Jagdalpur, Chhattisgarh",
            completion: "90%",
            health: "Delayed",
            head_name: "Sumit Goyal",
            color: 'green',
        },
        {
            change_number: "P-004",
            project_name: "Screening Plant 4",
            location: "Donimalai, Karnataka",
            completion: "50%",
            health: "On Track",
            head_name: "Shivam Yadav",
            color: 'red',
        },
    ];

    const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

    return (
        <>
            <Box sx={{ width: "100%" }}>
                <Grid2 container spacing={3} sx={{ mt: 5 }}>
                    <Grid2 size={12}>
                        <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '700', color: '#252525', mb: 3, lineHeight: "32px", letterSpacing: '-0.4px' }}>
                            Portfolio Dashboard
                        </Typography>
                        <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', color: '#000000', mb: 1, lineHeight: "100%", letterSpacing: '-0.4px' }}>
                            Status overview of all Projects
                        </Typography>
                        <Typography variant="h5" sx={{ fontSize: '18px', fontWeight: '400', color: '#182A4E80', mb: 2, lineHeight: "100%", letterSpacing: '-0.4px' }}>
                            Get the snapshot of the status of all your currently running projects. You can also navigate to the individual project dashboards
                        </Typography>
                    </Grid2>
                    <Grid2 size={5}>
                        <ProjectMap />
                    </Grid2>
                    <Grid2 size={7}>
                        <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 1 }}>
                            {/* <Typography variant="h6" sx={{ p: 1, pb: 0 }}>
                                Project Summary
                            </Typography> */}
                            <Table>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                        {columns.map((col) => (
                                            <StyledTableHead key={col.field} sx={{ fontWeight: 'bold' }}>
                                                {col.name}
                                            </StyledTableHead>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {projectList?.data?.data?.map((row, idx) => (
                                        <TableRow
                                            key={idx}
                                            hover
                                            sx={{ '&:last-child td': { borderBottom: 0 } }}
                                        >
                                            <StyledTableRow>{row?.project_name}</StyledTableRow>
                                            <StyledTableRow>{`${row?.budgeted_cost}`}</StyledTableRow>
                                            <StyledTableRow>
                                                {`${row?.city ?? ''}${row?.city ? ', ' : ''}${row?.state ?? ''}`}
                                            </StyledTableRow>
                                            {/* <StyledTableRow>{row.completion}</StyledTableRow> */}
                                            {/* <StyledTableRow sx={{ textAlign: 'center' }}>
                                                <GoDotFill style={{
                                                    fontSize: '30px', color: row?.color
                                                }} />
                                            </StyledTableRow> */}
                                            <StyledTableRow>{row?.project_manager_name}</StyledTableRow>
                                            <StyledTableRow>
                                                <IconButton aria-label="delete" size="small">
                                                    <IoCall fontSize="inherit" onClick={() => window.location.href = `tel:${row?.project_manager_phoneno}`} />
                                                </IconButton>
                                                <IconButton aria-label="delete" size="small"
                                                    onClick={() => {
                                                        localStorage.setItem('projectUrl', encrypt('project-landing'));
                                                        navigate(`/projects/${row?.project_id}?type=project-landing`, { replace: true });
                                                    }}
                                                >
                                                    <MdDirections fontSize="inherit" />
                                                </IconButton>
                                            </StyledTableRow>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    );
};

export default ProjectHome;